import React, { Component } from 'react';
import NavMenu from '../NavMenu/NavMenu'
import {Container} from "react-bootstrap";
import './index.css';

class designing extends Component {
    state = {  }
    render() { 
        return (
            <div>
                 <NavMenu />
                <div className="designingheader">
                    <Container className="text-center text-white my-auto">
                        <h3 className="mb-1 display-4 h3title">Проектування</h3>
                    </Container>
                </div>

                <Container>
                    <p className="designingtext">
                    <span className="titletext">Проектування інженерних систем</span> - важливий процес, що полягає у
                    власному розрахунку системи, оцінці необхідної кількості, а також
                    номенклатури обладнання.<span className="titletext">ФОП Полевік </span> забезпечує своєчасне
                    виконання вимог клієнта у повному обсязі при оптимальному
                    співвідношенні якості, ціни та термінів виконання.
                    </p>



                    <h2 className="h2designing">Етапи створення проекту:</h2>

                    <ul className="designinglist">
                        <li>отримання технічного завдання від замовника;</li>
                        <li>створення попереднього проектного рішення;</li>
                        <li>отримання технічних умов;</li>
                        <li>виконання проекту;</li>
                        <li>погодження з усіма причетними інстанціями.</li>
                    </ul>

                    <p style={{marginBottom:"5%"}} className="designingtext">
                    Ми комплексно підходимо до процесу проектування інженерних
                    систем - враховуємо специфіку об&#39;єкта, нормативні вимоги і
                    використовуємо сучасні технологічні рішення. Розрахунки
                    здійснюються висококваліфікованими фахівцями із застосуванням
                    сучасного програмного забезпечення, що дозволяє оптимізувати
                    технічні рішення і досягти максимальної якості проектної
                    документації.
                    </p>

                </Container>
            </div>
          );
    }
}
 
export default designing;